import {supabase} from './supabaseClient'

export const FOSC_PDF_BYTE_LIMIT=8*1024*1024
const failure=code=>Object.assign(new Error(code),{code})
const PATH=/^\/api\/v1\/publications\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/pdf$/i
export function foscPublicationId(value) {
  if(typeof value!=='string'||value.length>200)return null
  try {
    const url=new URL(value),match=PATH.exec(url.pathname)
    return url.protocol==='https:'&&url.hostname==='amtsblattportal.ch'&&!url.port&&!url.username&&!url.password&&!url.search&&!url.hash&&match?match[1].toLowerCase():null
  }catch{return null}
}
export async function readFoscPublicationFile({url,expectedUserId,signal,client=supabase}={}) {
  const publicationId=foscPublicationId(url)
  if(!publicationId)throw failure('invalid_document')
  if(!expectedUserId)throw failure('auth_changed')
  const controller=new AbortController()
  let timer,onAbort
  const deadline=new Promise((_,reject)=>{
    onAbort=()=>{controller.abort();reject(failure('aborted'))}
    signal?.addEventListener('abort',onAbort,{once:true})
    if(signal?.aborted)onAbort()
    timer=window.setTimeout(()=>{controller.abort();reject(failure('timeout'))},20000)
  })
  const currentSession=async()=>{
    if(controller.signal.aborted)throw failure('aborted')
    const {data,error}=await client.auth.getSession()
    if(controller.signal.aborted)throw failure('aborted')
    const session=data?.session
    if(error||session?.user?.id!==expectedUserId||!session?.access_token)throw failure('auth_changed')
    return session
  }
  const work=Promise.resolve().then(async()=>{
    const session=await currentSession()
    const result=await client.functions.invoke('registry-publication-file',{
      body:{publicationId},headers:{Authorization:'Bearer '+session.access_token},signal:controller.signal,
    })
    if(controller.signal.aborted)throw failure('aborted')
    const blob=result.data
    if(result.error||!(blob instanceof Blob)||!/^application\/pdf(?:;|$)/i.test(blob.type)||blob.size<5||blob.size>FOSC_PDF_BYTE_LIMIT)throw failure('invalid_document')
    const bytes=new Uint8Array(await blob.arrayBuffer())
    if(controller.signal.aborted)throw failure('aborted')
    if(bytes.length!==blob.size||bytes.length>FOSC_PDF_BYTE_LIMIT||String.fromCharCode(...bytes.slice(0,5))!=='%PDF-')throw failure('invalid_document')
    await currentSession()
    return bytes
  })
  try{return await Promise.race([work,deadline])}
  finally{window.clearTimeout(timer);signal?.removeEventListener('abort',onAbort)}
}
